<template>
  <div class="modal-body terms-conditions " v-html="Terms"></div>

</template>

<script>

import Axios from 'axios';
import tagFunctions from '@/utils/tagFunctions.js'
export default {
  name: "Terms",
  props: {
    name: {
      type: String,
      default: "cuamoc.com.mx",
    },
    

  },
  data() {
    return {
      Terms: '',
    }
  },
  async mounted() {
    tagFunctions.user_interactionPush(
      "view",
      "terminos y condiciones",
      "footer"
    );
    let serviceResponse = await Axios.get('https://api-mx-marketing.azure-api.net/sitios/tycos',{ 
      headers:{campaign :'general'}
    })
    this.Terms = serviceResponse.data.replace('{', '').replace('"body":"', '').replace(`";`, '').replace(`}`, '').replace(`}`, '').replace("[[urlsitio]]", "https://tecate.com/tecate0.0/")
  }
};
</script>
<style lang="scss" >
.terms-conditions {
  font-family: 'TerminaMedium' !important;
  font-size: 0.9rem !important;
  margin-right: 4.2pt !important;
  text-align: justify;
  h3, p {
    margin: 0;
    margin-bottom: 1rem
  }
  b {
    font-size: 0.9rem !important;
  }
  *{
  font-family: 'TerminaMedium' !important;
  font-size: 0.9rem !important;
  }
}

@media screen and (max-width: 768px) {
  .terms-conditions {
    font-size: 0.8rem !important;
    b {
      font-size: 0.7rem !important;
    }
    * {
      font-family: "TerminaMedium" !important;
      font-size: 0.8rem !important;
    }
  }
}
</style>
